/**
 * SubCategoryPageV2 — redesigned shell for the Subcategories list.
 *
 * PageHeader (eyebrow + h1 + total chip + sub + coral New) on top,
 * SubCategoriesTableV2 below. The total chip counts non-audiobook
 * subcategories so it matches what the table actually shows.
 */
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SubCategoriesTableV2 from '../../SubCategoriesTable/v2/SubCategoriesTableV2';
import { PageHeader, Button } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function SubCategoryPageV2() {
  const allSubcategories = useSelector((s) => s.subcategories.subcategories);

  const totalLabel = useMemo(() => {
    if (!allSubcategories) return undefined;
    const visible = Object.values(allSubcategories).filter(
      (s) => !s.subcategory_is_book,
    );
    const total  = visible.length;
    const active = visible.filter((s) => s.subcategory_is_active).length;
    return `${total.toLocaleString()} total · ${active.toLocaleString()} active`;
  }, [allSubcategories]);

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Library"
        title="Subcategories"
        total={totalLabel}
        actions={
          <Link to="/subcategories/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>New subcategory</Button>
          </Link>
        }
      />
      <SubCategoriesTableV2 />
    </div>
  );
}
